import script from "./AverageScoreTrendChart.vue?vue&type=script&setup=true&lang=js"
export * from "./AverageScoreTrendChart.vue?vue&type=script&setup=true&lang=js"

import "./AverageScoreTrendChart.vue?vue&type=style&index=0&id=657a25a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-657a25a2"]])

export default __exports__